import { createContext } from "react";

export const VehiclePageIsPrint = createContext({
  isPrint: false,
  setIsPrint: () => {},
});
